import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { FeaturesBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { backgroundImage } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundImage";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import {
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { FeatureBlock2 as Block } from "./FeatureBlock2";
import { defaultData } from "./FeatureBlock2DefaultData";
import { defaultStyles } from "./defaultStyles";
import imagePreview from "./feature_block_2_preview.png";

export const FeatureBlock2: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Feature Block 2",
    nameI18n:
      "settings.emails.visual_builder.block_type.feature_block.feature_block_2",
    version: 1,
    category: [FeaturesBlock],
    props: {
      headerContent: {
        name: "Header Content",
        nameI18n: "settings.emails.visual_builder.prop_type.header_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      section1Content: {
        name: "Section 1 Content",
        nameI18n: "settings.emails.visual_builder.prop_type.section_1_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      section2Content: {
        name: "Section 2 Content",
        nameI18n: "settings.emails.visual_builder.prop_type.section_2_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      footerContent: {
        name: "Footer Content",
        nameI18n: "settings.emails.visual_builder.prop_type.footer_content",
        prop: "children",
        accepts: ["Basic", "Media", "Text", "Actions"],
        type: "children",
      },
      styles: {
        name: "Styles",
        nameI18n: "builder_ui.prop_type.styles",
        prop: "styles",
        type: "styles",
        attributes: {
          backgroundColor: {
            ...backgroundColor,
            category: [DesignProp, GeneralProp],
            defaultValue: defaultStyles.backgroundColor,
            type: "color-without-alpha",
            nameI18n:
              "settings.emails.visual_builder.prop_type.styles.background_color",
          },
          backgroundImage: {
            ...backgroundImage,
            category: [DesignProp, GeneralProp],
          },
          padding: {
            ...padding,
            category: [DesignProp, PaddingsProp],
            defaultValue: defaultStyles.padding,
          },
          margin: {
            ...margin,
            category: [DesignProp, MarginsProp],
            defaultValue: defaultStyles.margin,
          },
        },
      },
    },
  },
};
